import { hasMemberOrganisationAccess, isOrganisationGroupUser } from "../OrganisationGroups/utils/roleAccess";

export const hasAuthenticatedUserData = (userData) =>
  Boolean(userData && typeof userData === "object" && Object.keys(userData).length);

export const getAuthToken = (userData) =>
  userData?.token || localStorage.getItem("token") || null;

export const getAuthenticatedHomeRoute = (userData, schoolData) => {
  if (isOrganisationGroupUser(userData) && !hasMemberOrganisationAccess(userData)) {
    return "/organisations/dashboard";
  }

  const isTrialMode =
    schoolData?.isTrial ||
    schoolData?.schoolId?.trialInfo?.isTrial ||
    schoolData?.trialInfo?.isTrial ||
    userData?.isTrial ||
    userData?.schoolId?.trialInfo?.isTrial ||
    userData?.trialInfo?.isTrial;

  if (isTrialMode && (userData?.role === "School" || userData?.role === "Teacher")) {
    return "/browse";
  }

  return "/dashboard";
};

export const isAllowedAuthenticatedRoute = (pathname, userData, schoolData) => {
  if (!pathname) return false;
  if (!hasAuthenticatedUserData(userData)) return false;

  const isTrialMode =
    schoolData?.isTrial ||
    schoolData?.schoolId?.trialInfo?.isTrial ||
    schoolData?.trialInfo?.isTrial ||
    userData?.isTrial ||
    userData?.schoolId?.trialInfo?.isTrial ||
    userData?.trialInfo?.isTrial;

  if (isTrialMode && pathname.startsWith("/dashboard")) {
    return false;
  }

  const isOrganisationRoute = pathname.startsWith("/organisations");
  const isVideoShortsRoute = pathname.startsWith("/video-shorts");
  const isSettingsRoute = pathname.startsWith("/settings");
  const isHelpRoute = pathname.startsWith("/help-support");
  
  if (isOrganisationRoute) {
    return isOrganisationGroupUser(userData);
  } else if (isVideoShortsRoute || isSettingsRoute || isHelpRoute) {
    return hasMemberOrganisationAccess(userData) || isOrganisationGroupUser(userData);
  } else {
    return hasMemberOrganisationAccess(userData);
  }
};
